import { render } from "./Sentence.vue?vue&type=template&id=c054c424&scoped=true"
import script from "./Sentence.vue?vue&type=script&lang=js"
export * from "./Sentence.vue?vue&type=script&lang=js"

import "./Sentence.vue?vue&type=style&index=0&id=c054c424&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c054c424"]])

export default __exports__